import { useEffect } from "react";

import nextCookie from "next-cookies";
import Head from "next/head";

import { productsApi } from "../services/api";
import ClipLoader from "react-spinners/ClipLoader";

import SidebarPage from "../components/SidebarPage";
import ProductList from "../components/ProductList";
import Pagination from "../components/Pagination";
import {Loading} from "../styles/busca";

const Outlet = ({ products, pages, token, cart_token }) => {
  const [loading, setLoading] = React.useState(false);

  async function loadScreen(isLoading){
    setLoading(isLoading);
    setTimeout(() => {
      setLoading(false)
    }, 5000)
}

  return (
    <>
            {loading ?
              <Loading>
                <ClipLoader color={'#F37A24'} loading={loading} size={80} />
              </Loading>
              :
              ""
              } 
    <SidebarPage token={token} loadScreen={loadScreen}>
      <Head>
        <title key="title">Outlet | Goods Br</title>
        <meta key="og-title" property="og:title" content="Outlet | Goods Br" />
      </Head>
      <ProductList title={"Outlet"} products={products} cart_token={cart_token}>
        <Pagination pages={pages} baseHref={`/outlet`} />
      </ProductList>
    </SidebarPage>
    </>
  );
};

Outlet.getInitialProps = async ctx => {
  const { token } = nextCookie(ctx);
  const { page } = ctx.query;

  const { products, pages } = await productsApi.outlet({
    user_token: token,
    page
  });

  return {
    products,
    pages,
    token
  };
};

export default Outlet;
